import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=19a9560b&scoped=true"
import script from "./calculator.vue?vue&type=script&lang=ts"
export * from "./calculator.vue?vue&type=script&lang=ts"
import style0 from "./calculator.vue?vue&type=style&index=0&id=19a9560b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_c2c4f8d10a02e12364bd9a7337709f82/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a9560b",
  null
  
)

export default component.exports